var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.0002,
    cy: 5.99922,
    r: 4.8,
    fill: "#1B1A1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00031 0C2.68611 0 3.25568e-08 2.68611 3.25568e-08 5.99969C-8.20546e-05 6.78768 0.155065 7.56798 0.456579 8.29601C0.758094 9.02403 1.20007 9.68554 1.75727 10.2427C2.31446 10.7999 2.97597 11.2419 3.70399 11.5434C4.43202 11.8449 5.21232 12.0001 6.00031 12C9.31326 12 12 9.31389 12 5.99969C12 2.68611 9.31326 0 6.00031 0ZM6.56028 2.16614C7.14525 2.16614 7.31712 2.50549 7.31712 2.8936C7.31712 3.37795 6.92964 3.82605 6.2678 3.82605C5.71408 3.82605 5.45034 3.54794 5.46659 3.08734C5.46659 2.69923 5.79095 2.16614 6.56028 2.16614ZM5.06161 9.59325C4.66163 9.59325 4.36977 9.35014 4.64913 8.28457L5.10723 6.39404C5.1866 6.09156 5.19973 5.97031 5.10723 5.97031C4.98787 5.97031 4.46852 6.17905 4.16228 6.38529L3.96292 6.05843C4.93474 5.2466 6.05218 4.77038 6.53028 4.77038C6.93026 4.77038 6.99651 5.24285 6.79715 5.97031L6.27217 7.95771C6.17905 8.30894 6.21905 8.43019 6.31217 8.43019C6.43216 8.43019 6.82464 8.28519 7.21087 7.98083L7.43711 8.28457C6.49154 9.22952 5.46097 9.59325 5.06161 9.59325Z",
    fill: "#FFC900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.dbfa4627b4c7ba319f5438b61a9a58eb.svg";
export { ForwardRef as ReactComponent };